// Create a reusable HTML Parser component
import React from "react";

/**
 * Utility to strip HTML tags from a string
 * @param {string} htmlString - The HTML string to strip tags from
 * @returns {string} The text content without HTML tags
 */
const stripHtml = (htmlString) => {
  if (!htmlString) return "";

  // Create a temporary div element to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;

  // Return the text content
  return tempDiv.textContent || "";
};

/**
 * Component to safely render HTML content
 * @param {string} html - The HTML content to render
 * @param {object} options - Additional options for the component
 * @returns {React.ReactElement} The parsed HTML content
 */
const HTMLContent = ({ html, ...props }) => {
  if (!html) return null;

  return <div {...props} dangerouslySetInnerHTML={{ __html: html }} />;
};

/**
 * Component to display HTML content as plain text (strips all HTML tags)
 * @param {string} html - The HTML content to strip tags from
 * @param {number} maxLength - Maximum length of text before truncating
 * @param {object} props - Additional props for the component
 * @returns {React.ReactElement} The plain text content
 */
const HTMLStripped = ({ html, maxLength, ...props }) => {
  if (!html) return null;

  try {
    let text = stripHtml(html);
    if (maxLength && text.length > maxLength) {
      text = text.substring(0, maxLength) + "...";
    }
    return <div {...props}>{text}</div>;
  } catch (error) {
    console.error("Error processing HTML:", error);
    return <div {...props}>{html}</div>;
  }
};

export { HTMLContent, HTMLStripped, stripHtml };
